import { render, staticRenderFns } from "./DispatchV3.html?vue&type=template&id=44a05ff8&scoped=true&external"
import script from "./DispatchV3.js?vue&type=script&lang=js&external"
export * from "./DispatchV3.js?vue&type=script&lang=js&external"
import style0 from "./DispatchV3.vue?vue&type=style&index=0&id=44a05ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a05ff8",
  null
  
)

export default component.exports